/**
 * Pure geo utilities. No I/O — API-based reverse geocoding lives in
 * `data/apis/locationiq.js`.
 */

const EARTH_RADIUS_KM = 6371;

/**
 * Great-circle distance via the Haversine formula.
 * @param {number} lat1
 * @param {number} lon1
 * @param {number} lat2
 * @param {number} lon2
 * @returns {number} kilometres
 */
export function haversineKm(lat1, lon1, lat2, lon2) {
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return 2 * EARTH_RADIUS_KM * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

/** @param {number} deg */
function toRad(deg) {
  return (deg * Math.PI) / 180;
}

/**
 * Format a distance for display: < 1km → "850 מטר", else "1.2 ק״מ".
 * @param {number} km
 * @returns {string}
 */
export function formatDistance(km) {
  if (!Number.isFinite(km) || km < 0) return '';
  if (km < 1) return `${Math.round(km * 1000)} מטר`;
  return `${km.toFixed(1)} ק״מ`;
}
